import * as React from 'react';
import Flex, { Props as FlexProps } from '../Flex/Flex';
import ProgressBar from '../Progress/ProgressBar';

export interface Props extends FlexProps {
  /** A number between 0 and 1 that represents the progress to display */
  progress: number;
}

/**
 * ModalHeader progress bar
 */
const ModalHeaderProgress: React.FunctionComponent<Props> = (props: Props) => {
  const { progress, ...rest } = props;

  return (
    <Flex { ...rest } className="ModalHeader__progress">
      <ProgressBar
          foregroundColor="eggplant"
          height="4px"
          progress={ progress } />
    </Flex>
  );
};

export default ModalHeaderProgress;
